import { render } from "./p-address.vue?vue&type=template&id=4873b2da"
import script from "./p-address.vue?vue&type=script&lang=js"
export * from "./p-address.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__